export const translations = {
  es: {
    nav: {
      about: "Sobre Mí",
      coaching: "Coaching",
      results: "Resultados",
      content: "Contenido",
      blog: "Blog",
      contact: "Contacto",
      apply: "APLICA AHORA",
    },
    hero: {
      eyebrow: "ELITE COACHING · PLAYA DEL CARMEN",
      title1: "TRANSFORMA TU CUERPO.",
      title2: "DOMINA TU VIDA.",
      subtitle: "Coaching fitness elite desde Playa del Carmen al mundo.",
      ctaPrimary: "APLICA AL COACHING",
      ctaSecondary: "Mira Mi Historia",
      scroll: "Desliza",
    },
    stats: {
      followers: "Seguidores",
      views: "Views Totales",
      years: "Años Coaching",
      languages: "Idiomas",
    },
    sponsors: {
      title: "MARCAS QUE CONFÍAN EN JORGE",
    },
    about: {
      eyebrow: "SOBRE JORGE",
      title: "33 AÑOS, TRES IDIOMAS,\nUNA MISIÓN.",
      p1: "Soy Jorge Aguilar Valenzuela, fundador de Masterfit. Llevo más de 8 años creando contenido fitness en Instagram, TikTok y YouTube, ayudando a miles de personas a transformar su físico y su mentalidad.",
      p2: "Desde Playa del Carmen entreno y asesoro clientes de todo el mundo en español, inglés y francés. Mi enfoque es claro: entrenamiento inteligente, nutrición sostenible y disciplina inquebrantable.",
      stat1: "252K",
      stat1Label: "Instagram",
      stat2: "328K",
      stat2Label: "TikTok",
      stat3: "18.6K",
      stat3Label: "YouTube",
    },
    forWho: {
      eyebrow: "¿ESTO ES PARA TI?",
      title: "PARA QUIÉN SÍ.\nPARA QUIÉN NO.",
      yesTitle: "ES PARA TI SI...",
      noTitle: "NO ES PARA TI SI...",
      yes: [
        "Estás listo para comprometerte mínimo 3 meses",
        "Quieres resultados reales, no atajos",
        "Buscas un coach que responda y guíe de cerca",
        "Estás dispuesto a invertir en tu salud y físico",
        "Quieres entrenar con método científico y progresivo",
      ],
      no: [
        "Buscas resultados milagrosos en 7 días",
        "No tienes tiempo para entrenar 4-5 días por semana",
        "No estás dispuesto a ajustar tu nutrición",
        "Solo quieres un PDF genérico copiado de internet",
        "No vas a comunicarte ni dar seguimiento",
      ],
    },
    pricing: {
      eyebrow: "INVERSIÓN",
      title: "ELIGE TU NIVEL DE COACHING",
      subtitle: "Compromiso mínimo 3 meses. Planes de pago disponibles.",
      perMonth: "/mes USD",
      popular: "MÁS ELEGIDO",
      cta: "APLICA AHORA",
      tiers: [
        {
          name: "ESSENTIAL",
          price: "800",
          tagline: "Construye la base.",
          features: [
            "Programa de entrenamiento personalizado",
            "Plan nutricional adaptado a tu objetivo",
            "Check-in quincenal por mensaje",
            "Revisión y ajuste mensual",
            "Acceso a guías Masterfit",
          ],
        },
        {
          name: "PREMIUM",
          price: "1,200",
          tagline: "Acelera el resultado.",
          highlight: true,
          features: [
            "Todo lo de Essential, más:",
            "Videollamada estratégica semanal",
            "WhatsApp 24/7 con Jorge",
            "Revisión técnica en video de tus ejercicios",
            "Soporte prioritario y ajustes rápidos",
          ],
        },
        {
          name: "ELITE",
          price: "1,500",
          tagline: "Transformación total.",
          features: [
            "Todo lo de Premium, más:",
            "Check-ins diarios",
            "Sesiones presenciales en Playa del Carmen",
            "Acceso a eventos y retiros exclusivos",
            "Plan de mentalidad y lifestyle",
          ],
        },
      ],
    },
    results: {
      eyebrow: "TRANSFORMACIONES",
      title: "RESULTADOS REALES.",
      subtitle: "Atletas y clientes que dejaron las excusas atrás.",
    },
    content: {
      eyebrow: "CONTENIDO",
      title: "ENTRENA CONMIGO TODOS LOS DÍAS",
      subtitle: "Más de 600K seguidores. Contenido diario gratis en redes.",
      followBtn: "SÍGUEME",
      watchBtn: "VER YOUTUBE",
    },
    blog: {
      eyebrow: "RECURSOS",
      title: "ARTÍCULOS Y GUÍAS",
      subtitle: "Conocimiento aplicable. Sin relleno.",
      readMore: "Leer artículo",
      categories: {
        training: "Entrenamiento",
        nutrition: "Nutrición",
        lifestyle: "Lifestyle",
        events: "Eventos",
      },
      posts: [
        {
          cat: "training",
          title: "Cómo construir hombros 3D sin lesionarte",
          excerpt: "El blueprint exacto que uso con mis clientes Premium para hombros redondos y saludables.",
        },
        {
          cat: "nutrition",
          title: "Nutrición sostenible: come para vivir, no sobrevivir",
          excerpt: "Olvida las dietas extremas. Te enseño el método que aplico hace 8 años.",
        },
        {
          cat: "lifestyle",
          title: "Disciplina sobre motivación: la regla del 70%",
          excerpt: "Por qué los días que no quieres entrenar son los más importantes.",
        },
      ],
    },
    contact: {
      eyebrow: "APLICA AL COACHING",
      title: "DA EL PRIMER PASO.",
      subtitle: "Llena el formulario. Si encajamos, te contacto en 24-48 horas.",
      name: "Nombre completo",
      email: "Email",
      instagram: "Tu Instagram (opcional)",
      level: "Tu nivel fitness actual",
      goals: "Tus objetivos principales",
      budget: "Presupuesto mensual",
      submit: "ENVIAR APLICACIÓN",
      submitting: "Enviando...",
      success: "Aplicación recibida. Te contactaré pronto vía email o WhatsApp.",
      error: "Algo falló. Inténtalo de nuevo o escríbeme por WhatsApp.",
      levels: ["Principiante", "Intermedio", "Avanzado"],
      budgets: ["$800 USD/mes", "$1,200 USD/mes", "$1,500 USD/mes", "Necesito orientación"],
      info: "INFO DIRECTA",
      location: "Playa del Carmen, Quintana Roo",
      schedule: "Agenda llamada por WhatsApp",
    },
    footer: {
      tagline: "Coaching fitness elite. Desde Playa del Carmen al mundo.",
      newsletter: "Recibe mi guía de 7 días gratis",
      newsletterPlaceholder: "tu@email.com",
      newsletterCta: "DESCARGAR",
      newsletterSuccess: "¡Listo! Revisa tu email.",
      links: "ENLACES",
      legal: "LEGAL",
      privacy: "Aviso de Privacidad",
      terms: "Términos y Condiciones",
      rights: "Todos los derechos reservados.",
      follow: "SÍGUEME",
    },
    exitPopup: {
      badge: "7 DÍAS GRATIS",
      title: "PRUEBA 7 DÍAS GRATIS",
      subtitle: "Elige tu plan y empieza hoy — sin compromiso.",
      male: "Hombre",
      female: "Mujer",
      close: "No gracias",
    },
    trainingPlans: {
      eyebrow: "PLANES AUTOMATIZADOS",
      title: "PLANES DE ENTRENAMIENTO",
      subtitle: "Entrenamiento guiado por Jorge, 5 días a la semana. Empieza con 7 días gratis.",
      trialBadge: "1 SEMANA GRATIS",
      perMonth: "/mes MXN",
      cta: "EMPEZAR GRATIS",
      plans: [
        {
          name: "POWER",
          tagline: "Plan de Fuerza",
          price: "999",
          description: "Programa de fuerza e hipertrofia. 5 días de entrenamiento de lunes a viernes.",
          features: [
            "Rutinas de fuerza progresiva",
            "Pecho, espalda, hombros, brazos y pierna",
            "Videos demostrativos de cada ejercicio",
            "Seguimiento desde la app Harbiz",
            "Actualización semanal del programa",
          ],
        },
        {
          name: "BOOTY",
          tagline: "Plan de Glúteos",
          price: "999",
          description: "Programa enfocado en glúteos y pierna. 5 días de entrenamiento de lunes a viernes.",
          features: [
            "Rutinas de glúteo y tren inferior",
            "Combinación tren inferior + superior",
            "Videos demostrativos de cada ejercicio",
            "Seguimiento desde la app Harbiz",
            "Actualización semanal del programa",
          ],
        },
      ],
    },
    sticky: {
      apply: "APLICA AL COACHING",
    },
  },
  en: {
    nav: {
      about: "About",
      coaching: "Coaching",
      results: "Results",
      content: "Content",
      blog: "Blog",
      contact: "Contact",
      apply: "APPLY NOW",
    },
    hero: {
      eyebrow: "ELITE COACHING · PLAYA DEL CARMEN",
      title1: "TRANSFORM YOUR BODY.",
      title2: "MASTER YOUR LIFE.",
      subtitle: "Elite fitness coaching from Playa del Carmen to the world.",
      ctaPrimary: "APPLY FOR COACHING",
      ctaSecondary: "Watch My Story",
      scroll: "Scroll",
    },
    stats: {
      followers: "Followers",
      views: "Total Views",
      years: "Coaching Years",
      languages: "Languages",
    },
    sponsors: {
      title: "BRANDS THAT TRUST JORGE",
    },
    about: {
      eyebrow: "ABOUT JORGE",
      title: "33 YEARS, THREE LANGUAGES,\nONE MISSION.",
      p1: "I'm Jorge Aguilar Valenzuela, founder of Masterfit. For over 8 years I've been creating fitness content on Instagram, TikTok, and YouTube, helping thousands transform their physique and mindset.",
      p2: "Based in Playa del Carmen, I train and coach clients worldwide in Spanish, English, and French. My approach is clear: smart training, sustainable nutrition, unbreakable discipline.",
      stat1: "252K",
      stat1Label: "Instagram",
      stat2: "328K",
      stat2Label: "TikTok",
      stat3: "18.6K",
      stat3Label: "YouTube",
    },
    forWho: {
      eyebrow: "IS THIS FOR YOU?",
      title: "WHO IT'S FOR.\nWHO IT'S NOT.",
      yesTitle: "FOR YOU IF...",
      noTitle: "NOT FOR YOU IF...",
      yes: [
        "You're ready to commit at least 3 months",
        "You want real results, not shortcuts",
        "You want a coach who answers and guides closely",
        "You're willing to invest in your health and body",
        "You want scientific, progressive training",
      ],
      no: [
        "You expect miracle results in 7 days",
        "You can't train 4-5 days per week",
        "You won't adjust your nutrition",
        "You just want a generic PDF from the internet",
        "You won't communicate or follow up",
      ],
    },
    pricing: {
      eyebrow: "INVESTMENT",
      title: "CHOOSE YOUR COACHING LEVEL",
      subtitle: "Minimum 3-month commitment. Payment plans available.",
      perMonth: "/mo USD",
      popular: "MOST CHOSEN",
      cta: "APPLY NOW",
      tiers: [
        {
          name: "ESSENTIAL",
          price: "800",
          tagline: "Build the foundation.",
          features: [
            "Personalized training program",
            "Nutrition plan tailored to your goal",
            "Bi-weekly check-in via message",
            "Monthly review and adjustment",
            "Access to Masterfit guides",
          ],
        },
        {
          name: "PREMIUM",
          price: "1,200",
          tagline: "Accelerate your results.",
          highlight: true,
          features: [
            "Everything in Essential, plus:",
            "Weekly strategic video call",
            "24/7 WhatsApp access to Jorge",
            "Video review of your technique",
            "Priority support and quick adjustments",
          ],
        },
        {
          name: "ELITE",
          price: "1,500",
          tagline: "Total transformation.",
          features: [
            "Everything in Premium, plus:",
            "Daily check-ins",
            "In-person sessions in Playa del Carmen",
            "Access to exclusive events and retreats",
            "Mindset and lifestyle plan",
          ],
        },
      ],
    },
    results: {
      eyebrow: "TRANSFORMATIONS",
      title: "REAL RESULTS.",
      subtitle: "Athletes and clients who left excuses behind.",
    },
    content: {
      eyebrow: "CONTENT",
      title: "TRAIN WITH ME EVERY DAY",
      subtitle: "Over 600K followers. Free daily content on socials.",
      followBtn: "FOLLOW ME",
      watchBtn: "WATCH YOUTUBE",
    },
    blog: {
      eyebrow: "RESOURCES",
      title: "ARTICLES & GUIDES",
      subtitle: "Applicable knowledge. No fluff.",
      readMore: "Read article",
      categories: {
        training: "Training",
        nutrition: "Nutrition",
        lifestyle: "Lifestyle",
        events: "Events",
      },
      posts: [
        {
          cat: "training",
          title: "How to build 3D shoulders without injury",
          excerpt: "The exact blueprint I use with Premium clients for round, healthy shoulders.",
        },
        {
          cat: "nutrition",
          title: "Sustainable nutrition: eat to live, not survive",
          excerpt: "Forget extreme diets. I teach the method I've used for 8 years.",
        },
        {
          cat: "lifestyle",
          title: "Discipline over motivation: the 70% rule",
          excerpt: "Why the days you don't want to train are the most important.",
        },
      ],
    },
    contact: {
      eyebrow: "APPLY FOR COACHING",
      title: "TAKE THE FIRST STEP.",
      subtitle: "Fill the form. If we're a fit, I'll reach out in 24-48 hours.",
      name: "Full name",
      email: "Email",
      instagram: "Your Instagram (optional)",
      level: "Your current fitness level",
      goals: "Your main goals",
      budget: "Monthly budget",
      submit: "SEND APPLICATION",
      submitting: "Sending...",
      success: "Application received. I'll reach out via email or WhatsApp.",
      error: "Something failed. Try again or message me on WhatsApp.",
      levels: ["Beginner", "Intermediate", "Advanced"],
      budgets: ["$800 USD/mo", "$1,200 USD/mo", "$1,500 USD/mo", "Need guidance"],
      info: "DIRECT INFO",
      location: "Playa del Carmen, Quintana Roo",
      schedule: "Schedule a call via WhatsApp",
    },
    footer: {
      tagline: "Elite fitness coaching. From Playa del Carmen to the world.",
      newsletter: "Get my free 7-day training guide",
      newsletterPlaceholder: "your@email.com",
      newsletterCta: "DOWNLOAD",
      newsletterSuccess: "Done! Check your email.",
      links: "LINKS",
      legal: "LEGAL",
      privacy: "Privacy Policy",
      terms: "Terms & Conditions",
      rights: "All rights reserved.",
      follow: "FOLLOW ME",
    },
    exitPopup: {
      badge: "7 DAYS FREE",
      title: "TRY 7 DAYS FREE",
      subtitle: "Choose your plan and start today — no commitment.",
      male: "Male",
      female: "Female",
      close: "No thanks",
    },
    trainingPlans: {
      eyebrow: "AUTOMATED PLANS",
      title: "TRAINING PLANS",
      subtitle: "Training guided by Jorge, 5 days a week. Start with 7 free days.",
      trialBadge: "1 FREE WEEK",
      perMonth: "/mo MXN",
      cta: "START FREE",
      plans: [
        {
          name: "POWER",
          tagline: "Strength Plan",
          price: "999",
          description: "Strength and hypertrophy program. 5 training days Monday to Friday.",
          features: [
            "Progressive strength routines",
            "Chest, back, shoulders, arms and legs",
            "Demo videos for every exercise",
            "Track progress via Harbiz app",
            "Weekly program updates",
          ],
        },
        {
          name: "BOOTY",
          tagline: "Glutes Plan",
          price: "999",
          description: "Glutes and leg focused program. 5 training days Monday to Friday.",
          features: [
            "Glute and lower body routines",
            "Lower + upper body combination",
            "Demo videos for every exercise",
            "Track progress via Harbiz app",
            "Weekly program updates",
          ],
        },
      ],
    },
    sticky: {
      apply: "APPLY FOR COACHING",
    },
  },
};
